import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import 'core-js/stable/regexp';

import 'intersection-observer';
import 'formdata-polyfill';
// to support window.scrollTo on IE11
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
